/**
 * Thulir Product Page v2 — Gallery, Variants, Cart, Sticky Bar, Lightbox, Upsell
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-thulir-product]');
  if (!section) return;

  var productJson = {};
  try {
    productJson = JSON.parse(
      document.querySelector('[data-thulir-product-json]').textContent
    );
  } catch (e) { /* no product json */ }

  var variants = productJson.variants || [];

  // Product minimum order quantity (product.metafields.custom.minimum_order_quantity), ≥1.
  var productMoq = parseInt(section.getAttribute('data-moq'), 10);
  if (isNaN(productMoq) || productMoq < 1) productMoq = 1;

  /* ─── Availability + stock (mirror of the section's Liquid) ───
     A tracked variant (inventory managed, policy not "continue") holding fewer
     units than the MOQ can't be ordered, so it counts as sold out. Low-stock
     copy is tiered — exact count below `low_num`, "a few left" below `low_few`;
     no MOQ → 5 / 10, with an MOQ → 1.5× / 2× the floor. */

  function variantTracked(v) {
    return !!(v && v.inventory_management) && v.inventory_policy !== 'continue';
  }

  function isBuyable(v) {
    if (!v || !v.available) return false;
    if (variantTracked(v) && v.inventory_quantity < productMoq) return false;
    return true;
  }

  function stockLabel(v) {
    if (!isBuyable(v) || !variantTracked(v)) return '';
    var lowNum = productMoq > 1 ? productMoq * 1.5 : 5;
    var lowFew = productMoq > 1 ? productMoq * 2 : 10;
    if (v.inventory_quantity < lowNum) return 'Only ' + v.inventory_quantity + ' left';
    if (v.inventory_quantity < lowFew) return 'Only a few left';
    return '';
  }

  /* ─── Gallery ─── */

  var thumbs = section.querySelectorAll('.thulir-product__thumb');
  var mobileThumbs = section.querySelectorAll('.thulir-product__mobile-thumb');
  var mainImages = section.querySelectorAll('[data-thulir-media-main] img');
  var currentImageIndex = 0;
  var totalImages = mainImages.length;

  function setActiveImage(index, direction) {
    if (index === currentImageIndex) return;
    // Determine slide direction: 'left' means new image enters from right (next),
    // 'right' means new image enters from left (prev).
    var dir = direction || (index > currentImageIndex ? 'left' : 'right');
    var prevIndex = currentImageIndex;
    currentImageIndex = index;

    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });
    mobileThumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === index);
    });

    // Slide transition: exit the old image, enter the new one
    mainImages.forEach(function (img, i) {
      if (i === prevIndex) {
        // Old image exits
        img.classList.remove('is-active');
        img.classList.add(dir === 'left' ? 'is-exiting-left' : 'is-exiting-right');
      } else if (i === index) {
        // Position new image off-screen instantly (no transition), then slide in
        img.style.transition = 'none';
        img.classList.remove('is-exiting-left', 'is-exiting-right', 'is-active');
        // Force the off-screen position
        img.style.transform = dir === 'left' ? 'translateX(100%)' : 'translateX(-100%)';
        img.style.opacity = '0';
        // Force reflow so the position takes effect before we animate
        void img.offsetWidth;
        // Re-enable transition and slide in
        img.style.transition = '';
        img.style.transform = '';
        img.style.opacity = '';
        img.classList.add('is-active');
      } else {
        img.classList.remove('is-active', 'is-exiting-left', 'is-exiting-right');
      }
    });

    // Clean up exiting classes after transition ends
    setTimeout(function () {
      mainImages.forEach(function (img) {
        img.classList.remove('is-exiting-left', 'is-exiting-right');
      });
    }, 650);

    scrollThumbIntoView(index);
  }

  function scrollThumbIntoView(index) {
    // Centre the active thumb inside its own scroll container only — using
    // scrollIntoView here would also scroll the whole (sticky) page.
    centreThumb(section.querySelector('[data-thulir-thumbs]'), thumbs[index], true);
    centreThumb(section.querySelector('[data-thulir-mobile-thumbs]'), mobileThumbs[index], false);
    var counterCurrent = section.querySelector('[data-gallery-current]');
    if (counterCurrent) counterCurrent.textContent = index + 1;
  }

  function centreThumb(container, el, vertical) {
    if (!container || !el) return;
    var c = container.getBoundingClientRect();
    var e = el.getBoundingClientRect();
    if (vertical) {
      container.scrollBy({ top: (e.top - c.top) - (container.clientHeight - el.offsetHeight) / 2, behavior: 'smooth' });
    } else {
      container.scrollBy({ left: (e.left - c.left) - (container.clientWidth - el.offsetWidth) / 2, behavior: 'smooth' });
    }
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(thumb.getAttribute('data-index'), 10);
      setActiveImage(idx);
    });
  });

  mobileThumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var idx = parseInt(thumb.getAttribute('data-index'), 10);
      setActiveImage(idx);
    });
  });

  /* ─── Gallery Swipe (touch) ─── */

  var mediaMain = section.querySelector('[data-thulir-media-main]');
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipeThreshold = 40;

  if (mediaMain && totalImages > 1) {
    mediaMain.addEventListener('touchstart', function (e) {
      swipeStartX = e.touches[0].clientX;
      swipeStartY = e.touches[0].clientY;
    }, { passive: true });

    mediaMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - swipeStartX;
      var dy = e.changedTouches[0].clientY - swipeStartY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > swipeThreshold) {
        if (dx < 0) {
          setActiveImage((currentImageIndex + 1) % totalImages, 'left');
        } else if (dx > 0) {
          setActiveImage((currentImageIndex - 1 + totalImages) % totalImages, 'right');
        }
      }
    }, { passive: true });
  }

  /* ─── Gallery Prev/Next Arrows (on main image) ─── */

  var galleryPrev = section.querySelector('[data-gallery-prev]');
  var galleryNext = section.querySelector('[data-gallery-next]');

  if (galleryPrev) {
    galleryPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      setActiveImage((currentImageIndex - 1 + totalImages) % totalImages, 'right');
    });
  }
  if (galleryNext) {
    galleryNext.addEventListener('click', function (e) {
      e.stopPropagation();
      setActiveImage((currentImageIndex + 1) % totalImages, 'left');
    });
  }

  /* ─── Thumbnail Strip Arrows ─── */

  var thumbsContainer = section.querySelector('[data-thulir-thumbs]');
  var mobileThumbsContainer = section.querySelector('[data-thulir-mobile-thumbs]');

  function setupThumbArrows(container) {
    if (!container) return;
    var isVertical = container.classList.contains('thulir-product__thumbs');
    var scrollAmount = isVertical ? 180 : 160;

    var prevArrow = container.parentElement.querySelector('[data-thumb-prev]');
    var nextArrow = container.parentElement.querySelector('[data-thumb-next]');

    function updateArrowVisibility() {
      var overflows = isVertical
        ? container.scrollHeight > container.clientHeight + 2
        : container.scrollWidth > container.clientWidth + 2;
      if (prevArrow) prevArrow.style.display = overflows ? '' : 'none';
      if (nextArrow) nextArrow.style.display = overflows ? '' : 'none';
    }

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        container.scrollBy({ [isVertical ? 'top' : 'left']: -scrollAmount, behavior: 'smooth' });
      });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        container.scrollBy({ [isVertical ? 'top' : 'left']: scrollAmount, behavior: 'smooth' });
      });
    }

    updateArrowVisibility();
    window.addEventListener('resize', updateArrowVisibility);
  }

  setupThumbArrows(thumbsContainer);
  setupThumbArrows(mobileThumbsContainer);

  /* ─── Lightbox ─── */

  var lightbox = document.querySelector('[data-thulir-lightbox]');
  var lightboxImg = lightbox ? lightbox.querySelector('[data-thulir-lightbox-img]') : null;
  var lightboxClose = lightbox ? lightbox.querySelector('[data-thulir-lightbox-close]') : null;
  var lightboxPrev = lightbox ? lightbox.querySelector('[data-thulir-lightbox-prev]') : null;
  var lightboxNext = lightbox ? lightbox.querySelector('[data-thulir-lightbox-next]') : null;
  var lightboxHint = lightbox ? lightbox.querySelector('.thulir-product__lightbox-hint') : null;
  var lightboxImgWrap = lightbox ? lightbox.querySelector('.thulir-product__lightbox-img-wrap') : null;
  var lightboxZoomed = false;
  var lightboxScale = 1;
  var lightboxPanX = 0;
  var lightboxPanY = 0;
  var lightboxSuppressClick = false;
  var lightboxSuppressClickTimer = null;

  function suppressNextLightboxClick() {
    lightboxSuppressClick = true;
    window.clearTimeout(lightboxSuppressClickTimer);
    lightboxSuppressClickTimer = window.setTimeout(function () {
      lightboxSuppressClick = false;
    }, 500);
  }

  function updateLightboxHint() {
    if (!lightboxHint) return;
    var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (lightboxZoomed) {
      lightboxHint.textContent = coarsePointer
        ? 'Swipe to explore • pinch to zoom'
        : 'Drag to explore • click to reset';
    } else {
      lightboxHint.textContent = coarsePointer
        ? 'Pinch to zoom • swipe for next image'
        : 'Click image to zoom';
    }
  }

  function clampLightboxPan() {
    if (!lightboxImg || !lightboxImgWrap || lightboxScale <= 1) {
      lightboxPanX = 0;
      lightboxPanY = 0;
      return;
    }
    var maxX = Math.max(0, (lightboxImg.offsetWidth * lightboxScale - lightboxImgWrap.clientWidth) / 2);
    var maxY = Math.max(0, (lightboxImg.offsetHeight * lightboxScale - lightboxImgWrap.clientHeight) / 2);
    lightboxPanX = Math.max(-maxX, Math.min(maxX, lightboxPanX));
    lightboxPanY = Math.max(-maxY, Math.min(maxY, lightboxPanY));
  }

  function renderLightboxTransform() {
    if (!lightboxImg) return;
    clampLightboxPan();
    lightboxImg.style.transformOrigin = 'center center';
    lightboxImg.style.transform = 'translate3d(' + lightboxPanX + 'px, ' + lightboxPanY + 'px, 0) scale(' + lightboxScale + ')';
    lightboxImg.style.cursor = lightboxZoomed ? 'grab' : 'zoom-in';
    updateLightboxHint();
  }

  function resetLightboxZoom() {
    lightboxScale = 1;
    lightboxPanX = 0;
    lightboxPanY = 0;
    lightboxZoomed = false;
    renderLightboxTransform();
  }

  function setLightboxScale(scale, clientX, clientY) {
    if (!lightboxImgWrap) return;
    var oldScale = lightboxScale;
    var nextScale = Math.min(4, Math.max(1, scale));
    if (typeof clientX === 'number' && typeof clientY === 'number' && oldScale > 0) {
      var wrapRect = lightboxImgWrap.getBoundingClientRect();
      var focalX = clientX - (wrapRect.left + wrapRect.width / 2);
      var focalY = clientY - (wrapRect.top + wrapRect.height / 2);
      var ratio = nextScale / oldScale;
      lightboxPanX = focalX - (focalX - lightboxPanX) * ratio;
      lightboxPanY = focalY - (focalY - lightboxPanY) * ratio;
    }
    lightboxScale = nextScale;
    lightboxZoomed = lightboxScale > 1.001;
    if (!lightboxZoomed) {
      lightboxPanX = 0;
      lightboxPanY = 0;
    }
    renderLightboxTransform();
  }

  function openLightbox(index) {
    if (!lightbox || !lightboxImg || !mainImages.length) return;
    currentImageIndex = index;
    resetLightboxZoom();
    var img = mainImages[index];
    if (img) {
      lightboxImg.src = img.currentSrc || img.src;
      lightboxImg.alt = img.alt;
    }
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    resetLightboxZoom();
  }

  function lightboxNavigate(direction) {
    if (totalImages < 2) return;
    var newIndex = (currentImageIndex + direction + totalImages) % totalImages;
    setActiveImage(newIndex);
    resetLightboxZoom();
    var img = mainImages[newIndex];
    if (img && lightboxImg) {
      lightboxImg.src = img.currentSrc || img.src;
      lightboxImg.alt = img.alt;
    }
  }

  /* Lightbox zoom on click — zoom at click point */
  if (lightboxImg) {
    lightboxImg.addEventListener('click', function (e) {
      e.stopPropagation();
      var coarsePointer = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      if (coarsePointer) return;
      if (lightboxSuppressClick) {
        lightboxSuppressClick = false;
        return;
      }
      if (lightboxZoomed) {
        resetLightboxZoom();
      } else {
        setLightboxScale(2.5, e.clientX, e.clientY);
      }
    });
  }

  /* Pointer Events keep two-finger state reliable across iOS and Android. */
  var lightboxTouchPointers = new Map();
  var lightboxTouchMode = '';
  var lightboxGestureStartDistance = 0;
  var lightboxGestureStartScale = 1;
  var lightboxGestureStartX = 0;
  var lightboxGestureStartY = 0;
  var lightboxGestureStartPanX = 0;
  var lightboxGestureStartPanY = 0;
  var lightboxGestureLastX = 0;
  var lightboxGestureLastY = 0;
  var lightboxGestureMoved = false;

  function lightboxPointerValues() {
    return Array.from(lightboxTouchPointers.values());
  }

  function lightboxPointerDistance(points) {
    return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
  }

  function beginLightboxPan(point) {
    lightboxTouchMode = 'pan';
    lightboxGestureStartX = point.x;
    lightboxGestureStartY = point.y;
    lightboxGestureStartPanX = lightboxPanX;
    lightboxGestureStartPanY = lightboxPanY;
    lightboxGestureMoved = false;
  }

  function beginLightboxPinch() {
    var points = lightboxPointerValues();
    if (points.length < 2) return;
    lightboxTouchMode = 'pinch';
    lightboxGestureStartDistance = lightboxPointerDistance(points);
    lightboxGestureStartScale = lightboxScale;
    lightboxGestureMoved = true;
  }

  function finishLightboxTouchPointer(e, cancelled) {
    var endingPoint = lightboxTouchPointers.get(e.pointerId);
    if (endingPoint) {
      endingPoint.x = e.clientX;
      endingPoint.y = e.clientY;
    }
    var previousMode = lightboxTouchMode;
    lightboxTouchPointers.delete(e.pointerId);

    if (lightbox.hasPointerCapture && lightbox.hasPointerCapture(e.pointerId)) {
      lightbox.releasePointerCapture(e.pointerId);
    }

    if (previousMode === 'pinch' || cancelled) {
      lightboxTouchPointers.forEach(function (_, pointerId) {
        if (lightbox.hasPointerCapture && lightbox.hasPointerCapture(pointerId)) {
          lightbox.releasePointerCapture(pointerId);
        }
      });
      lightboxTouchPointers.clear();
      lightboxTouchMode = '';
      lightboxGestureMoved = false;
      if (!cancelled && lightboxScale < 1.02) resetLightboxZoom();
      suppressNextLightboxClick();
      return;
    }

    var remaining = lightboxPointerValues();
    if (remaining.length >= 2) {
      beginLightboxPinch();
      return;
    }
    if (remaining.length === 0) {
      if (!cancelled && previousMode === 'swipe' && !lightboxZoomed) {
        var dx = lightboxGestureLastX - lightboxGestureStartX;
        if (Math.abs(dx) > swipeThreshold) lightboxNavigate(dx < 0 ? 1 : -1);
      }
      if (lightboxGestureMoved || previousMode === 'pinch') suppressNextLightboxClick();
      lightboxTouchMode = '';
      lightboxGestureMoved = false;
    }
  }

  if (lightboxImgWrap && lightbox) {
    lightbox.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'touch') return;
      e.preventDefault();
      lightboxTouchPointers.set(e.pointerId, {
        x: e.clientX,
        y: e.clientY,
        insideImage: lightboxImgWrap.contains(e.target)
      });
      if (lightbox.setPointerCapture) lightbox.setPointerCapture(e.pointerId);

      var points = lightboxPointerValues();
      if (points.length >= 2) {
        beginLightboxPinch();
      } else if (lightboxZoomed && points[0].insideImage) {
        beginLightboxPan(points[0]);
      } else if (!lightboxZoomed) {
        lightboxTouchMode = 'swipe';
        lightboxGestureStartX = e.clientX;
        lightboxGestureStartY = e.clientY;
        lightboxGestureLastX = e.clientX;
        lightboxGestureLastY = e.clientY;
        lightboxGestureMoved = false;
      }
    });

    lightbox.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'touch' || !lightboxTouchPointers.has(e.pointerId)) return;
      e.preventDefault();
      var point = lightboxTouchPointers.get(e.pointerId);
      point.x = e.clientX;
      point.y = e.clientY;
      var points = lightboxPointerValues();

      if (lightboxTouchMode === 'pinch' && points.length >= 2 && lightboxGestureStartDistance > 0) {
        var distance = lightboxPointerDistance(points);
        var midX = (points[0].x + points[1].x) / 2;
        var midY = (points[0].y + points[1].y) / 2;
        setLightboxScale(lightboxGestureStartScale * (distance / lightboxGestureStartDistance), midX, midY);
      } else if (lightboxTouchMode === 'pan' && lightboxZoomed) {
        var dx = point.x - lightboxGestureStartX;
        var dy = point.y - lightboxGestureStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) lightboxGestureMoved = true;
        lightboxPanX = lightboxGestureStartPanX + dx;
        lightboxPanY = lightboxGestureStartPanY + dy;
        renderLightboxTransform();
      } else if (lightboxTouchMode === 'swipe') {
        lightboxGestureLastX = point.x;
        lightboxGestureLastY = point.y;
        if (Math.abs(point.x - lightboxGestureStartX) > 3 || Math.abs(point.y - lightboxGestureStartY) > 3) {
          lightboxGestureMoved = true;
        }
      }
    });

    lightbox.addEventListener('pointerup', function (e) {
      if (e.pointerType === 'touch') finishLightboxTouchPointer(e, false);
    });
    lightbox.addEventListener('pointercancel', function (e) {
      if (e.pointerType === 'touch') finishLightboxTouchPointer(e, true);
    });

    var lightboxMouseDrag = false;
    var lightboxMouseMoved = false;
    var lightboxMouseStartX = 0;
    var lightboxMouseStartY = 0;
    var lightboxMouseStartPanX = 0;
    var lightboxMouseStartPanY = 0;

    lightboxImgWrap.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch' || !lightboxZoomed || e.button !== 0) return;
      e.preventDefault();
      lightboxMouseDrag = true;
      lightboxMouseMoved = false;
      lightboxMouseStartX = e.clientX;
      lightboxMouseStartY = e.clientY;
      lightboxMouseStartPanX = lightboxPanX;
      lightboxMouseStartPanY = lightboxPanY;
      lightboxImg.style.cursor = 'grabbing';
      lightboxImgWrap.setPointerCapture(e.pointerId);
    });

    lightboxImgWrap.addEventListener('pointermove', function (e) {
      if (!lightboxMouseDrag) return;
      e.preventDefault();
      var dx = e.clientX - lightboxMouseStartX;
      var dy = e.clientY - lightboxMouseStartY;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) lightboxMouseMoved = true;
      lightboxPanX = lightboxMouseStartPanX + dx;
      lightboxPanY = lightboxMouseStartPanY + dy;
      renderLightboxTransform();
      lightboxImg.style.cursor = 'grabbing';
    });

    function finishLightboxMouseDrag(e) {
      if (!lightboxMouseDrag) return;
      lightboxMouseDrag = false;
      if (lightboxMouseMoved) suppressNextLightboxClick();
      if (lightboxImgWrap.hasPointerCapture(e.pointerId)) lightboxImgWrap.releasePointerCapture(e.pointerId);
      if (lightboxImg) lightboxImg.style.cursor = lightboxZoomed ? 'grab' : 'zoom-in';
    }

    lightboxImgWrap.addEventListener('pointerup', finishLightboxMouseDrag);
    lightboxImgWrap.addEventListener('pointercancel', finishLightboxMouseDrag);
  }

  // Click main image to open lightbox
  if (mediaMain) {
    mediaMain.addEventListener('click', function (e) {
      if (e.target.tagName === 'IMG') {
        openLightbox(currentImageIndex);
      }
    });
  }

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightboxPrev) lightboxPrev.addEventListener('click', function () { lightboxNavigate(-1); });
  if (lightboxNext) lightboxNext.addEventListener('click', function () { lightboxNavigate(1); });

  document.addEventListener('keydown', function (e) {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lightboxNavigate(-1);
    if (e.key === 'ArrowRight') lightboxNavigate(1);
  });

  if (lightbox) {
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
  }

  /* ─── Accordions — only one open at a time ─── */

  var accordions = section.querySelectorAll('.thulir-product__accordion');
  accordions.forEach(function (accordion) {
    accordion.addEventListener('toggle', function () {
      if (!accordion.open) return;

      var summary = accordion.querySelector('summary');
      /* Collapsing a sibling that sits ABOVE this one removes page height and
         shifts everything up, throwing the just-opened section out of view.
         Anchor on the clicked summary: measure it, collapse the others, then
         scroll by the difference so it stays put under the user's click. */
      var before = summary.getBoundingClientRect().top;
      accordions.forEach(function (other) {
        if (other !== accordion && other.open) other.open = false;
      });
      var delta = summary.getBoundingClientRect().top - before;
      if (delta) window.scrollBy(0, delta);
    });
  });

  /* ─── Variant Picker ─── */

  var variantButtons = section.querySelectorAll('.thulir-product__option-value');
  var selectedOptions = [];

  if (productJson.options) {
    productJson.options.forEach(function (optName, i) {
      var selectedBtn = section.querySelector('[data-option-position="' + (i + 1) + '"] .is-selected');
      selectedOptions[i] = selectedBtn ? selectedBtn.getAttribute('data-value') : '';
    });
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt === selectedOptions[i];
      });
    });
  }

  function updateVariantUI(variant) {
    if (!variant) return;

    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    var stickyPrice = document.querySelector('[data-sticky-bar-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    var buyable = isBuyable(variant);

    var atcBtn = section.querySelector('[data-add-to-cart]');
    if (atcBtn) {
      atcBtn.disabled = !buyable;
      atcBtn.textContent = 'Add to Cart';
    }

    var stickyAtc = document.querySelector('[data-sticky-bar-atc]');
    if (stickyAtc) stickyAtc.disabled = !buyable;

    // Buy It Now (Shop Pay) can't be disabled — hide it entirely when sold out.
    var dynamicCheckout = section.querySelector('[data-dynamic-checkout]');
    if (dynamicCheckout) dynamicCheckout.hidden = !buyable;

    // Sold out (incl. stock below the MOQ) → swap the buy block for the
    // "Currently Unavailable" status + the "I want this" demand button, and
    // mirror that state on the sticky bar (CSS hides qty/choose/ATC there).
    var buyControls = section.querySelector('[data-thulir-buy-controls]');
    if (buyControls) buyControls.hidden = !buyable;
    var unavailable = section.querySelector('[data-thulir-unavailable]');
    if (unavailable) unavailable.hidden = buyable;
    var wantBtn = section.querySelector('[data-thulir-want]');
    if (wantBtn) wantBtn.hidden = buyable;
    var stickyBarEl = document.querySelector('[data-thulir-sticky-bar]');
    if (stickyBarEl) stickyBarEl.classList.toggle('thulir-product__sticky-bar--sold-out', !buyable);

    var variantInput = section.querySelector('[data-variant-id-input]');
    if (variantInput) variantInput.value = variant.id;

    updateStock(variant);

    // New variant → recompute cap/in-cart, re-clamp qty, repaint notes.
    if (typeof setQuantity === 'function') setQuantity(currentQty());

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    if (typeof variant.image_index === 'number' && variant.image_index >= 0) {
      setActiveImage(variant.image_index);
    }
  }

  function updateStock(variant) {
    var stockEl = section.querySelector('[data-thulir-stock]');
    if (!stockEl) return;
    var textEl = stockEl.querySelector('[data-stock-text]');
    var label = stockLabel(variant);
    if (textEl) textEl.textContent = label;
    stockEl.hidden = !label;
  }

  function updateOptionAvailability() {
    section.querySelectorAll('[data-option-position]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-option-position'), 10) - 1;
      group.querySelectorAll('.thulir-product__option-value').forEach(function (btn) {
        var test = selectedOptions.slice();
        test[pos] = btn.getAttribute('data-value');
        var match = variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === test[i]; });
        });
        btn.classList.toggle('is-unavailable', !(match && isBuyable(match)));
      });
    });
  }

  // Single entry point for any option change (main pills OR cart-bar selects),
  // so both controls and the variant UI always stay in sync.
  function selectOption(position, value) {
    selectedOptions[position - 1] = value;

    var group = section.querySelector('[data-option-position="' + position + '"]');
    if (group) {
      group.querySelectorAll('.thulir-product__option-value').forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-value') === value);
      });
    }

    var barSelect = document.querySelector('[data-sticky-bar-option="' + position + '"]');
    if (barSelect && barSelect.value !== value) barSelect.value = value;

    var variant = findVariant();
    if (variant) updateVariantUI(variant);
    updateOptionAvailability();
  }

  variantButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var position = parseInt(btn.closest('[data-option-position]').getAttribute('data-option-position'), 10);
      selectOption(position, btn.getAttribute('data-value'));
    });
  });

  document.querySelectorAll('[data-sticky-bar-option]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      selectOption(parseInt(sel.getAttribute('data-sticky-bar-option'), 10), sel.value);
    });
  });

  updateOptionAvailability();

  /* ─── Quantity (main stepper + cart-bar stepper kept in sync) ─── */

  var qtyInput = section.querySelector('[data-qty-input]');
  var qtyHidden = section.querySelector('[data-qty-hidden]');
  var barQtyInput = document.querySelector('[data-sticky-bar-qty-input]');

  function currentQty() {
    return parseInt((qtyInput && qtyInput.value) || (barQtyInput && barQtyInput.value) || String(productMoq), 10) || productMoq;
  }

  function setQuantity(val) {
    // Effective ceiling is "how many more may still be added for this variant"
    // (cap − already-in-cart), falling back to the field's own max when the
    // cart-aware config isn't present. Floor is the product's MOQ — the field
    // never drops below it. Keep the field usable even when nothing more can be
    // added (Add button is disabled in that case) or when the headroom is below
    // the floor (Shopify's stock 422 is the backstop for that edge).
    var rem = remainingToAdd();
    var max = rem === Infinity
      ? (parseInt((qtyInput && qtyInput.getAttribute('max')) || '99', 10) || 99)
      : Math.max(1, rem);
    if (max < productMoq) max = productMoq;
    val = Math.max(productMoq, Math.min(val || productMoq, max));
    if (qtyInput) { qtyInput.value = val; if (rem !== Infinity) qtyInput.max = max; }
    if (qtyHidden) qtyHidden.value = val;
    if (barQtyInput) { barQtyInput.value = val; if (rem !== Infinity) barQtyInput.max = max; }
    refreshCartAwareUI();
  }

  [
    ['[data-qty-minus]', -1],
    ['[data-qty-plus]', 1],
    ['[data-sticky-bar-qty-minus]', -1],
    ['[data-sticky-bar-qty-plus]', 1]
  ].forEach(function (pair) {
    var el = document.querySelector(pair[0]);
    if (el) el.addEventListener('click', function () { setQuantity(currentQty() + pair[1]); });
  });

  if (qtyInput) qtyInput.addEventListener('change', function () { setQuantity(parseInt(qtyInput.value, 10)); });
  if (barQtyInput) barQtyInput.addEventListener('change', function () { setQuantity(parseInt(barQtyInput.value, 10)); });

  /* ─── Cart-aware quantity caps (sourced from cart-qty-config.liquid) ───
     Surfaces the same per-line cap the cart enforces, BEFORE the customer
     reaches the cart, and accounts for what they already have. Purely a
     progressive enhancement — guarded on window.thulirCartQty, with
     Shopify's 422 still the real backstop. */

  var qtyNote = section.querySelector('[data-thulir-qty-note]');
  var qtyNoteText = section.querySelector('[data-thulir-qty-note-text]');
  var qtyCap = section.querySelector('[data-thulir-qty-cap]');
  var stickyNote = document.querySelector('[data-thulir-sticky-bar-note]');
  var plusButtons = [
    section.querySelector('[data-qty-plus]'),
    document.querySelector('[data-sticky-bar-qty-plus]')
  ];
  var cartCountByVariant = {};   // variantId → quantity currently in cart

  function currentVariant() {
    return findVariant() || variants[0] || null;
  }

  function variantInCart(variantId) {
    return cartCountByVariant[variantId] || 0;
  }

  function variantCap(variant) {
    if (!variant || !window.thulirCartQty) return Infinity;
    var untracked = !variant.inventory_management || variant.inventory_policy === 'continue';
    return window.thulirCartQty.calcMaxQty(variant.inventory_quantity, untracked);
  }

  // How many more units may still be added for the selected variant.
  function remainingToAdd() {
    var v = currentVariant();
    var cap = variantCap(v);
    if (cap === Infinity) return Infinity;
    return Math.max(0, cap - variantInCart(v.id));
  }

  function setNote(el, html) {
    if (!el) return;
    if (html) { el.innerHTML = html; el.hidden = false; }
    else { el.innerHTML = ''; el.hidden = true; }
  }

  function refreshCartAwareUI() {
    var cfg = window.thulirCartQty;
    if (!cfg) return;
    var v = currentVariant();
    if (!v) return;

    var cap = variantCap(v);
    var inCart = variantInCart(v.id);
    var rem = cap === Infinity ? Infinity : Math.max(0, cap - inCart);
    // "Maxed" only applies to a real, in-stock cap. A zero cap means the
    // variant is sold out / out of stock — the sold-out UI owns that state,
    // so we don't render a "maximum (0)" message for it.
    var maxed = rem !== Infinity && rem <= 0 && cap > 0;
    var qty = currentQty();

    // 1) Informational in-cart note (+ View cart) — only the text swaps; the
    //    button is static markup so the whole <p> just toggles visibility.
    if (inCart > 0 && qtyNoteText) {
      qtyNoteText.innerHTML = cfg.buildInCartMessage(inCart);
      if (qtyNote) qtyNote.hidden = false;
    } else if (qtyNote) {
      qtyNote.hidden = true;
    }

    // 2) Cap message — "already maxed", or the standard per-order cap once
    //    this add would reach it (passes the section el for the bulk link).
    // A zero cap means sold out / out of stock — the sold-out UI owns that
    // state, so guard on cap > 0 here too (mirrors `maxed` above). Without it
    // a sold-out variant renders a bogus "Maximum 0 per order." note.
    var capHtml = '';
    if (maxed) capHtml = cfg.buildMaxedMessage(section, cap);
    else if (cap > 0 && cap !== Infinity && inCart + qty >= cap) capHtml = cfg.buildMessage(section, cap);
    else if (productMoq > 1 && qty <= productMoq) capHtml = cfg.buildMinMessage(productMoq);
    setNote(qtyCap, capHtml);

    // 3) Sticky bar compact note (maxed takes priority over the count).
    var stickyHtml = maxed ? cfg.buildMaxedMessage(section, cap)
                   : inCart > 0 ? cfg.buildInCartMessage(inCart) : '';
    setNote(stickyNote, stickyHtml);

    // 4) Block further adds when maxed — never override a sold-out variant
    //    (incl. stock below the MOQ, which the sold-out UI already owns).
    var soldOut = !isBuyable(v);
    plusButtons.forEach(function (b) { if (b) b.disabled = maxed; });

    var atc = section.querySelector('[data-add-to-cart]');
    if (atc && !soldOut) {
      atc.disabled = maxed;
      if (maxed) atc.textContent = 'Max in cart';
      else if (atc.textContent === 'Max in cart') atc.textContent = 'Add to Cart';
    }
    var stickyAtc = document.querySelector('[data-sticky-bar-atc]');
    if (stickyAtc && !soldOut) stickyAtc.disabled = maxed;
  }

  function refreshCartState() {
    if (!window.thulirCartQty) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartCountByVariant = {};
        (cart.items || []).forEach(function (it) {
          cartCountByVariant[it.variant_id] = (cartCountByVariant[it.variant_id] || 0) + it.quantity;
        });
        // Re-clamp the field to the freshly known headroom, then repaint.
        setQuantity(currentQty());
      })
      .catch(function () { /* progressive enhancement — ignore */ });
  }

  // Re-sync whenever the cart changes anywhere (drawer add / qty / remove).
  document.addEventListener('cart:updated', refreshCartState);

  refreshCartState();

  /* ─── Add to Cart (AJAX) ─── */

  var form = section.querySelector('[data-thulir-product-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = form.querySelector('[data-variant-id-input]').value;
      var quantity = parseInt(form.querySelector('[data-qty-hidden]').value, 10) || 1;
      var btn = form.querySelector('[data-add-to-cart]');

      btn.disabled = true;
      btn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: quantity }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          }, 1500);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Error – try again';
          setTimeout(function () {
            btn.textContent = 'Add to Cart';
          }, 2000);
        });
    });
  }

  /* ─── Sticky Bar ─── */

  var stickyBar = document.querySelector('[data-thulir-sticky-bar]');
  var addToCartBtn = section.querySelector('[data-add-to-cart]');

  // Desktop: sticky bar ATC triggers form submit
  var stickyAtcBtn = document.querySelector('[data-sticky-bar-atc]');
  if (stickyAtcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  // Mobile: "Choose Options" scrolls to the price so the whole buy block
  // (price → variants → quantity → Add to Cart) is in view below the header.
  var stickyChooseBtn = document.querySelector('[data-sticky-bar-choose]');
  if (stickyChooseBtn) {
    stickyChooseBtn.addEventListener('click', function () {
      var target = section.querySelector('[data-thulir-price]') || section.querySelector('.thulir-product__variants') || form;
      if (!target) return;
      var headerH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--thulir-header-h'), 10) || 80;
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
      window.scrollTo({ top: y, behavior: 'smooth' });
    });
  }

  // Show sticky bar as soon as the CTA scrolls out of viewport (downward). We
  // observe the CTA container, not the ATC button itself, because when the
  // variant is sold out the buy block (and its ATC) is hidden — only the
  // "I want this" button shows — and a display:none target never intersects.
  var ctaAnchor = section.querySelector('[data-thulir-cta]') || addToCartBtn;
  if (stickyBar && ctaAnchor && 'IntersectionObserver' in window) {
    var barObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          // CTA not visible — show bar only if scrolled past (top is above viewport)
          stickyBar.classList.toggle('is-visible', entry.boundingClientRect.top < 0);
        } else {
          // CTA visible — hide bar
          stickyBar.classList.remove('is-visible');
        }
      });
    }, { threshold: [0, 1] });
    barObserver.observe(ctaAnchor);
  }

  /* ─── Buy It With (Upsell via Recommendations API) ─── */

  var upsellContainer = section.querySelector('[data-thulir-upsell]');
  var upsellSlider = section.querySelector('[data-thulir-upsell-list]');
  var upsellDotsContainer = section.querySelector('[data-thulir-upsell-dots]');
  var productId = section.getAttribute('data-product-id');
  var upsellTrack = null;
  var upsellCount = 0;
  var upsellCurrentIndex = 0;
  var upsellAutoTimer = null;
  var upsellResetAuto = null;

  /* `pos` runs 0..upsellCount. The slide at index upsellCount is a clone of the
     first card, so the auto-loop glides forward onto it and then snaps back to
     0 (identical frame) — an endless one-direction slide with no backward jump. */
  function showUpsellSlide(pos, animate) {
    if (!upsellTrack || upsellCount === 0) return;
    upsellTrack.style.transition = animate === false ? 'none' : '';
    upsellTrack.style.transform = 'translateX(' + (-pos * 100) + '%)';
    if (animate === false) { void upsellTrack.offsetWidth; } // commit the snap before transitions resume
    upsellCurrentIndex = pos;
    var active = ((pos % upsellCount) + upsellCount) % upsellCount;
    upsellDotsContainer.querySelectorAll('.thulir-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === active);
    });
  }

  function buildUpsell(products) {
    if (products.length === 0) return;
    upsellCount = products.length;

    upsellTrack = document.createElement('div');
    upsellTrack.className = 'thulir-product__upsell-track';

    products.forEach(function (p, i) {
      var variant = p.variants[0];
      var imgSrc = p.featured_image ? p.featured_image.replace(/\.([^.]+)$/, '_300x375_crop_center.$1') : '';
      var card = document.createElement('div');
      card.className = 'thulir-product__upsell-card';
      card.setAttribute('data-variant-id', variant.id);
      card.innerHTML =
        '<a class="thulir-product__upsell-img" href="' + p.url + '">' +
          (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="100" height="134">' : '') +
        '</a>' +
        '<div class="thulir-product__upsell-content">' +
          '<p class="thulir-product__upsell-subtitle">Buy It With</p>' +
          '<div class="thulir-product__upsell-row">' +
            '<p class="thulir-product__upsell-title"><a href="' + p.url + '">' + escapeHtml(p.title) + '</a></p>' +
            '<p class="thulir-product__upsell-price">' + formatMoney(variant.price) + '</p>' +
          '</div>' +
          '<button type="button" class="thulir-product__upsell-btn" data-thulir-quick-buy data-variant-id="' + variant.id + '"' +
            (!variant.available ? ' disabled' : '') + '>' +
            (variant.available ? 'Quick Buy' : 'Sold Out') +
          '</button>' +
        '</div>';
      upsellTrack.appendChild(card);

      var dot = document.createElement('button');
      dot.className = 'thulir-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Show product ' + (i + 1));
      dot.addEventListener('click', function () { showUpsellSlide(i, true); if (upsellResetAuto) upsellResetAuto(); });
      upsellDotsContainer.appendChild(dot);
    });

    // Trailing clone of the first card so the loop from last → first glides
    // forward instead of rewinding. It's inert (briefly visible mid-transition).
    if (upsellCount > 1) {
      var clone = upsellTrack.firstChild.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.style.pointerEvents = 'none';
      upsellTrack.appendChild(clone);
    }

    upsellSlider.appendChild(upsellTrack);
    upsellContainer.removeAttribute('hidden');

    if (products.length <= 1) {
      upsellDotsContainer.style.display = 'none';
    }

    // Once the glide onto the trailing clone finishes, snap back to the real
    // first card (no animation) so the next advance keeps going forward.
    upsellTrack.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'transform' && upsellCurrentIndex >= upsellCount) {
        showUpsellSlide(0, false);
      }
    });

    // Swipe + auto-advance (forward loop; pauses while interacting)
    var ux = 0;

    function advance(dir) {
      if (upsellCount < 2) return;
      if (dir < 0 && upsellCurrentIndex <= 0) {
        // Back from the first card: jump onto the trailing clone (identical
        // frame, no flicker), then glide to the last real card.
        showUpsellSlide(upsellCount, false);
        requestAnimationFrame(function () { showUpsellSlide(upsellCount - 1, true); });
      } else {
        showUpsellSlide(upsellCurrentIndex + dir, true);
      }
    }

    function startAuto() {
      if (upsellCount < 2 || upsellAutoTimer) return;
      upsellAutoTimer = setInterval(function () { advance(1); }, 3500);
    }
    function stopAuto() {
      if (upsellAutoTimer) { clearInterval(upsellAutoTimer); upsellAutoTimer = null; }
    }
    upsellResetAuto = function () { stopAuto(); startAuto(); };

    upsellSlider.addEventListener('mouseenter', stopAuto);
    upsellSlider.addEventListener('mouseleave', startAuto);
    upsellSlider.addEventListener('touchstart', function (e) {
      stopAuto();
      ux = e.touches[0].clientX;
    }, { passive: true });
    upsellSlider.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - ux;
      if (Math.abs(dx) > swipeThreshold) {
        advance(dx < 0 ? 1 : -1);
      }
      startAuto();
    }, { passive: true });

    startAuto();
  }

  if (upsellContainer && upsellSlider && productId) {
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if ((data.products || []).length === 0) {
          return fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
            .then(function (r) { return r.json(); });
        }
        return data;
      })
      .then(function (data) { buildUpsell(data.products || []); })
      .catch(function () { /* silently fail */ });
  }

  /* Quick Buy handler (event delegation) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-thulir-quick-buy]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () { btn.textContent = 'Quick Buy'; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Error';
        setTimeout(function () { btn.textContent = 'Quick Buy'; btn.disabled = false; }, 1500);
      });
  });

  /* ─── Helpers ─── */

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

})();
